// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Hc6Yq","title":"styles_title__IVOpf","text":"styles_text__RIQ1V"};